// extracted by mini-css-extract-plugin
export default {"container":"Edit_container__NzHd2","img":"Edit_img__SmbiG","userWithoutAvatar":"Edit_userWithoutAvatar__toNJQ","title":"Edit_title__Mt2lc"};